import React, { forwardRef } from "react";

type PanelProps = {
    open: boolean;
    onClose: () => void;
    title: string;
    delayMode: 1 | 2;
    setDelayMode: (m: 1 | 2) => void;
    showLow: boolean;
    setShowLow: (v: boolean) => void;
    showMedium: boolean;
    setShowMedium: (v: boolean) => void;
    showHigh: boolean;
    setShowHigh: (v: boolean) => void;
    labels: {
        onboard: string;
        offboard: string;
        posToMsg: string;
        msgToSaved: string;
        displayLevels: string;
        low: string;
        medium: string;
        high: string;
    };
};

export const MapSettings = forwardRef<HTMLDivElement, PanelProps>(
    ({open, onClose, title, delayMode, setDelayMode, showLow, setShowLow, showMedium, setShowMedium, showHigh, setShowHigh, labels }, panelRef ) => {
        return (
            <>
                {open && (
                    <button
                        className="map-controls-backdrop"
                        onClick={onClose}
                        aria-label="Close settings"
                    />
                )}

                <div
                    id="map-controls"
                    ref={panelRef}
                    className={`map-controls ${open ? "open" : "close"}`}
                    role="dialog"
                    aria-label="Map controls"
                    aria-modal="false"
                >
                    <div className="mc-header">
                        <div className="mc-title">{title}</div>
                    </div>

                    <div className="mc-body">
                        <div className="mc-section">
                            <button
                                className={`mc-option ${delayMode === 1 ? "active" : ""}`}
                                onClick={() => setDelayMode(1)}
                            >
                                <div className="mc-option-title">
                                    <strong>{labels.onboard}</strong>
                                </div>
                                <div className="mc-option-desc">{labels.posToMsg}</div>
                            </button>

                            <button
                                className={`mc-option ${delayMode === 2 ? "active" : ""}`}
                                onClick={() => setDelayMode(2)}
                            >
                                <div className="mc-option-title">{labels.offboard}</div>
                                <div className="mc-option-desc">{labels.msgToSaved}</div>
                            </button>
                        </div>

                        <div className="mc-section">
                            <div className="mc-subtitle">{labels.displayLevels}</div>

                            <label className="mc-check">
                                <input
                                    type="checkbox"
                                    checked={showLow}
                                    onChange={(e) => setShowLow(e.target.checked)}
                                />
                                <img src="/assets/icons/green-dot.svg" width={16} height={16} alt="" />
                                <span>{labels.low}</span>
                            </label>

                            <label className="mc-check">
                                <input
                                    type="checkbox"
                                    checked={showMedium}
                                    onChange={(e) => setShowMedium(e.target.checked)}
                                />
                                <img src="/assets/icons/orange-dot.svg" width={16} height={16} alt="" />
                                <span>{labels.medium}</span>
                            </label>

                            <label className="mc-check">
                                <input
                                    type="checkbox"
                                    checked={showHigh}
                                    onChange={(e) => setShowHigh(e.target.checked)}
                                />
                                <img src="/assets/icons/red-dot.svg" width={16} height={16} alt="" />
                                <span>{labels.high}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </>
        );
    }
);
